import React from "react";
import { Link } from "react-router-dom";

import TableWrapper from "../../shared/bootstrap/TableWrapper.jsx";
import TableHeaderColumn from "../../shared/TableHeaderColumn.jsx";

import { generateEmail } from "../../../util/email.js";
import { HELP_EMAIL_ADDRESS } from "../../../constants.js";

/**
 * OrderGeneralInfo Component
 *
 * @param {Object} props
 * @param {number} props.chInfoSeq
 * @param {number} props.rfqSeq
 * @param {number} props.stnSeq
 * @param {string} props.awardDate
 * @param {string} props.chDisplayName
 * @param {string} props.chEmailsConcatenated
 * @param {string} props.companyName
 * @param {string} props.contractNumber
 * @param {string} props.deliveryStatus
 * @param {string} props.expDeliveryDate
 * @param {string} props.firstName
 * @param {string} props.lastName
 * @param {string} props.modDate
 * @param {number} props.modLevel
 * @param {string[]} props.orderNumbers
 * @param {string} props.orderStatus
 * @param {string} props.orderTotal
 * @param {0 | 1} props.rfqSeqFlag
 * @returns {React.JSX.Element}
 */
export default function OrderGeneralInfo({
  chInfoSeq,
  rfqSeq,
  stnSeq,
  awardDate,
  chDisplayName,
  chEmailsConcatenated,
  companyName,
  contractNumber,
  deliveryStatus,
  expDeliveryDate,
  firstName,
  lastName,
  modDate,
  modLevel,
  orderNumbers,
  orderStatus,
  orderTotal,
  rfqSeqFlag,
}) {
  const emailAll = generateEmail({
    recipientList: chEmailsConcatenated.trim(),
    ccList: HELP_EMAIL_ADDRESS,
    bccList: HELP_EMAIL_ADDRESS,
    subject: `Customer Question for Order Number: ${orderNumbers[0]}, STN: ${stnSeq}`,
    body: `Hi ${chDisplayName},\n\n<ADD YOUR MESSAGE HERE>\n\nFrom:\n${firstName} ${lastName}`,
  });

  const emailSEWP = generateEmail({
    recipientList: HELP_EMAIL_ADDRESS,
    subject: `Customer Question for Order Number: ${orderNumbers[0]}, STN: ${stnSeq}`,
    body: `Hi SEWP,\n\n<ADD YOUR MESSAGE HERE>\n\nFrom:\n${firstName} ${lastName}`,
  });

  return (
    <>
      <div className="panel-body">
        <TableWrapper id="generalInfo" summary={`Order Details for STN: ${stnSeq}`}>
          <thead role="rowgroup">
            <tr role="row">
              <TableHeaderColumn id="stnSeq-head" text="STN" />
              <TableHeaderColumn id="orderNumber-head" text="Order Number(s)" />
              <TableHeaderColumn id="rfqSeq-head" text="RFQ" />
              <TableHeaderColumn id="ch-head" text="Contract Holder" />
              <TableHeaderColumn id="contract-head" text="Contract Number" />
              <TableHeaderColumn id="ordertotal-head" text="Order Amount" />
              <TableHeaderColumn id="awardDate-head" text="Award Date" />
              <TableHeaderColumn id="modDate-head" text="Mod Date" />
              <TableHeaderColumn id="modLevel-head" text="Mod Level" />
            </tr>
          </thead>
          <tbody role="rowgroup">
            <tr role="row">
              <th role="rowheader" headers="stn-head">
                {stnSeq}
              </th>
              <td role="gridcell" headers="row-head name-head">
                <ul className="list-unstyled">
                  {orderNumbers.map((orderNumber, index) =>
                    index === 0 ? (
                      <li key={orderNumber}>
                        <strong>{orderNumber}</strong>
                      </li>
                    ) : (
                      <li key={orderNumber}>{orderNumber}</li>
                    )
                  )}
                </ul>
              </td>
              {rfqSeqFlag === 1 ? (
                <td className="text-center" role="gridcell">
                  <a href={`../sewp5public/detail.html?rs=${rfqSeq}`}>{rfqSeq}</a>
                </td>
              ) : (
                <td className="text-center" role="gridcell" title="You don't have access to this RFQ.">
                  {rfqSeq}
                </td>
              )}

              <td role="gridcell" headers="row-head">
                <Link to={`/sewp5public/contractholders#/detail/${chInfoSeq}`}>
                  {companyName} ({chDisplayName})
                </Link>
              </td>
              <td role="gridcell" headers="row-head">
                {contractNumber}
              </td>
              <td role="gridcell" headers="row-head">
                {orderTotal}
              </td>
              <td role="gridcell" headers="row-head">
                {awardDate}
              </td>
              <td role="gridcell" headers="row-head">
                {modDate}
              </td>
              <td role="gridcell" headers="row-head">
                {modLevel}
              </td>
            </tr>
          </tbody>
        </TableWrapper>

        <h5 className="text-center">
          <strong>Order Status: </strong>
          {orderStatus}
        </h5>
        <br />
        <h5 className="text-center">
          <strong>Delivery Status: </strong>
          {deliveryStatus}
        </h5>
        <h6 className="text-center">
          <strong>Expected Delivery Date: </strong>
          {expDeliveryDate}
        </h6>
      </div>
      <TableWrapper>
        <thead>
          <tr>
            <th className="center">
              Questions about your order? <a href={emailAll}>E-mail {chDisplayName} &amp; SEWP </a>
              OR <a href={emailSEWP}>E-mail SEWP Only</a>
            </th>
          </tr>
        </thead>
      </TableWrapper>
    </>
  );
}
